export default __webpack_public_path__ + "static/media/cotton.ab615a41.jpg";